import { FluxType } from 'flux/buildFlux';
import { useEffect, useRef, useState } from 'react';

import { flux } from '../singletons';

function useStores(stores: string[], mapper: (flux: FluxType) => any) {
  const [state, setState] = useState(mapper(flux));
  const mapperRef = useRef(mapper);
  const storesRef = useRef(stores);

  useEffect(() => {
    const currentStores = storesRef.current;
    const onStoreChange = () => setState(() => mapperRef.current(flux));
    currentStores.forEach((storeName) =>
      flux.stores[storeName].on('change', onStoreChange),
    );
    return () =>
      currentStores.forEach((storeName) =>
        flux.stores[storeName].removeListener('change', onStoreChange),
      );
  }, []);

  return state;
}

export default useStores;
